import { SELECT_JOBTYPE } from '../../constants/ActionConstants';

export const selectJobType = (jobType) => ({
    type: SELECT_JOBTYPE,
    data: { jobType: jobType }
});